import { observer } from 'mobx-react-lite'
import { useCallback, useEffect, useMemo } from 'react'
import { type ActionItem } from 'shared/ui'
import { NumbersListStore, PhoneApi } from 'entities/Phone'
import { getPhoneActions } from 'entities/Phone/ui/actions'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type RowNumber } from 'entities/Phone/model/Table/RowNumber'
import { NumbersTable } from 'pages/settings/pages/numbers/ui/NumbersTable'

export const AssignedNumbers = observer(() => {
  const entities = useEntitiesContext()
  const store = useMemo(
    () => new NumbersListStore('AdminNumbersList', PhoneApi.getNumbers, entities),
    []
  )

  useEffect(store.init, [])
  const getIsRowDisabled = useCallback((row: RowNumber) => !!row.origin.disabled, [])

  const getRowActions = (row: RowNumber): ActionItem[] => {
    return getPhoneActions(row.origin, entities, { loadData: store.loadData })
  }

  return (
    <NumbersTable
      ariaLabel={'AssignedNumbers'}
      numbersListStore={store}
      getIsRowDisabled={getIsRowDisabled}
      notFoundMessage={'No assigned number found'}
      getRowActions={getRowActions}
    />
  )
})
